import { APP_LOGO, rootStore } from "../StApp"
import { SwipeCard } from "./SwipeCard"
import img0 from '../assets/person0.jpeg'

export const SwipePotMatchStack = () => {

    return (
        < >
            {
                rootStore.matchStore.potMatches.map(item =>
                    <SwipeCard data={{ user: item, mainImgUrl: APP_LOGO, likeButton: false }}
                        upVote={() => rootStore.matchStore.commitMatch(item.uid)}
                        downVote={() => rootStore.matchStore.commitDump(item.uid)}
                    />).reverse()
            }

        </>

    )
}